import React from 'react';
import PropTypes from 'prop-types';
import forEach from '../../../javascripts/dom/forEach';

const buildSizes = sizes => {
  let sizesString = '';
  forEach(sizes, (index, size) => {
    if (size.condition) {
      sizesString += `(${size.condition}) `;
    }
    sizesString += `${size.width}, `;
  });
  return sizesString.replace(/,\s*$/, '');
};

const buildSrcSet = srcset => {
  let srcsetString = '';
  forEach(srcset, (index, src) => {
    if (src.suffix) {
      srcsetString += `${src.src} ${src.suffix}, `;
    } else {
      srcsetString += `${src.src}, `;
    }
  });
  return srcsetString.replace(/,\s*$/, '');
};

const Image = ({ alt, src, srcset, sizes, lazy, className }) => {
  let image = {
    src,
    alt
  };

  if (srcset && lazy) {
    image['data-srcset'] = buildSrcSet(srcset);
  } else if (srcset) {
    image.srcSet = buildSrcSet(srcset);
  }

  if (sizes && lazy) {
    image['data-sizes'] = buildSizes(sizes);
  } else if (sizes) {
    image.sizes = buildSizes(sizes);
  }

  if (lazy === 'lqip') {
    image = {
      ...image
    };
  } else if (lazy === 'default') {
    image = {
      ...image,
      'data-src': image.src
    };
  } else {
    image = {
      ...image
    };
  }

  return (
    // We pass it with ...image
    // eslint-disable-next-line jsx-a11y/alt-text
    <img className={`a-image ${className} ${lazy ? 'lazyload' : ''}`} {...image} />
  );
};

Image.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  srcset: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      suffix: PropTypes.string
    })
  ),
  sizes: PropTypes.arrayOf(
    PropTypes.shape({
      condition: PropTypes.string,
      width: PropTypes.string
    })
  ),
  lazy: PropTypes.oneOf(['default', 'lqip'])
};

Image.defaultProps = {
  className: '',
  alt: null,
  srcset: null,
  sizes: null,
  lazy: null
};

export default Image;
